// lib/honeypot.ts — module-level so the value never lands in persisted state.
export const honeypot = { current: "" };
